module.exports = {
	"homePage": {
		"CoverHeaderButton": {
			"headerBackgroundImages": [
				"image_bg_comp.jpg",
				"img_bg_about.jpg",
				"img_bg_1.jpg",
				"img_bg_services.jpg"
			],
			"headerTitle": "Header_Company_Name",
			"headerSubTitle": "Index_Motto",
			"buttonName": "Index_Get_In_Touch",
			"buttonTo": "contact",
			"buttonClass": "btn btn-white btn-lg btn-outline"
		},
		"Feature3Container": {
			"boxItemDetailsTeamServicesJobs": [
				{
					"title": "Index_Team",
					"description": "Index_Team_Text",
					"buttonLink": "#about-anchor",
					"buttonText": "Learn_More_Button",
					"buttonClass": "btn btn-white btn-outline",
					"icon": "ti-user",
					"class": "feature-1"
				},
				{
					"title": "Index_Services",
					"description": "Index_Services_Text",
					"buttonLink": "services",
					"buttonText": "Learn_More_Button",
					"buttonClass": "btn btn-white btn-outline",
					"icon": "ti-panel",
					"class": "feature-2"
				},
				{
					"title": "Index_Jobs",
					"description": "Index_Jobs_Text",
					"buttonLink": "career",
					"buttonText": "Learn_More_Button",
					"buttonClass": "btn btn-white btn-outline",
					"icon": "ti-ruler-pencil",
					"class": "feature-3"
				}
			]
		},
		"FeatureContainer": {
			"h2TitleParagraphFirst": {
				"title": "Index_Main_Title",
				"paragraph": "Index_Main_Title_Text"
			},
			"boxItemDetailsTechnicalPragmaticPersonal": [
				{
					"title": "Index_Main_SubTitle1",
					"description": "Index_Main_SubTitle1_Text",
					"icon": "ti-clip"
				},
				{
					"title": "Index_Main_SubTitle3",
					"description": "Index_Main_SubTitle3_Text",
					"icon": "ti-package"
				},
				{
					"title": "Index_Main_SubTitle2",
					"description": "Index_Main_SubTitle2_Text",
					"icon": "ti-face-smile"
				}
			]
		},
		"FeatureSectionContainer": {
			"h2TitleParagraphSecond": {
				"title": "Index_Meet_Team",
				"paragraph": "Index_Meet_Team_Description"
			},
			"bttsdTeam": [
				{
					"name": "Index_Name_Bert",
					"image": "Bert2-image.png",
					"jobTitle": "Index_JobTitle_Bert",
					"description": "Index_Bert_Description",
					"social": {
						"twitter": "https://twitter.com/saxi",
						"linkedin": "https://nl.linkedin.com/in/btandt",
						"email": "bert.steenbeeke@bttsd.ro"
					}
				},
				{
					"name": "Index_Name_Darius",
					"image": "darius-image.JPG",
					"jobTitle": "Index_JobTitle1",
					"description": "Index_Darius_Description",
					"social": {
						"email": "darius.popescu@bttsd.ro"
					}
				},
				{
					"name": "Index_Name_Cezar",
					"image": "cezar-image.JPG",
					"jobTitle": "Index_JobTitle1",
					"description": "Index_Cezar_Description",
					"social": {
						"email": "cezar.budulacu@bttsd.ro"
					}
				}
			]
		}
	},
	"aboutPage": {
		"CoverHeaderXs": [
			{
				"headerBackgroundImage": "img_bg_about.jpg",
				"headerSizeClass": "gtco-cover-xs",
				"headerTitle": "About_Main_Title",
				"headerSubTitle": "About_Main_Subtitle"
			}
		],
		"aboutTitlePhilosophy": {
			"title": "About_Our_Philosophy",
			"paragraph": "About_Our_Philosophy_Text"
		},
		"CounterFeature": {
			"aboutDevelopingInRomania": {
				"title": "About_Developing_Romania",
				"paragraph": "empty"
			},
			"aboutDevelopingInRomaniaParagraph": "About_Developing_Romania_Text",
			"featureRowItems": [
				{
					"icon": "ti-timer",
					"valueRandom": "4",
					"valueRandomLabel": "About_Developing_Hours"
				},
				{
					"icon": "ti-vector",
					"valueRandom": "7000",
					"valueRandomLabel": "About_Developing_Graduates"
				},
				{
					"icon": "ti-briefcase",
					"valueRandom": "100000",
					"valueRandomLabel": "About_Developing_Engineers"
				}
			],
			"carouselItems": [
				"about-ro-3.jpg",
				"about-ro-4.jpg",
				"about-ro-5.jpg",
				"about-ro-0.jpg",
				"about-ro-1.jpg",
				"about-ro-2.jpg"
			]
		},
		"FeatureTabs": {
			"ourWork": {
				"title": "Services_Main_SubTitle3",
				"paragraph": "Services_Main_SubTitle3_Text"
			},
			"tabData": [
				{
					"tabName": "Services_Our_Project1_Title",
					"tabIcon": "fa fa-skype",
					"tabContent": {
						"contentImage": "project-01-answering-call.png",
						"contentHeading": "Services_Our_Project1_tabContentHeading",
						"cotentParagraph": "Services_Our_Project1_tabContentParagraph",
						"contentHeadingTech": "Services_Our_Project1_tabContentTech",
						"techList": [
							"Skype for Business APIs",
							"JavaScript",
							"C#",
							"NET"
						]
					}
				},
				{
					"tabName": "Services_Our_Project2_Title",
					"tabIcon": "fa fa-exchange",
					"tabContent": {
						"contentImage": "project-01-select-timeslot.png",
						"contentHeading": "Services_Our_Project2_tabContentHeading",
						"cotentParagraph": "Services_Our_Project2_tabContentParagraph",
						"contentHeadingTech": "Services_Our_Project1_tabContentTech",
						"techList": [
							"C# Asp/.Net",
							"Bootstrap",
							"Javascript",
							"Google Calendar API",
							"Microsoft Calendar API"
						]
					}
				},
				{
					"tabName": "Services_Our_Project3_Title",
					"tabIcon": "fa fa-mobile",
					"tabContent": {
						"contentImage": "iris_mobile.jpg",
						"contentHeading": "Services_Our_Project3_tabContentHeading",
						"cotentParagraph": "Services_Our_Project3_tabContentParagraph",
						"contentHeadingTech": "Services_Our_Project1_tabContentTech",
						"techList": [
							"Appcelerator Titanium / JavaScript",
							"REST services",
							"Apple Developer Enterprise Program"
						]
					}
				},
				{
					"tabName": "Services_Our_Project4_Title",
					"tabIcon": "fa fa-asterisk",
					"tabContent": {
						"contentImage": "project-01-timeline.png",
						"contentHeading": "Services_Our_Project4_tabContentHeading",
						"cotentParagraph": "Services_Our_Project4_tabContentParagraph",
						"contentHeadingTech": "Services_Our_Project1_tabContentTech",
						"techList": [
							"Material design",
							"Bootstrap",
							"Microsoft SQL Server programming",
							"Javascript",
							"AngularJS"
						]
					}
				}
			]
		}
	},
	"servicesPage": {
		"CoverHeaderXs": [
			{
				"headerBackgroundImage": "img_bg_services.jpg",
				"headerSizeClass": "gtco-cover-xs",
				"headerTitle": "Services_Main_Title",
				"headerSubTitle": "Services_Main_TitleText"
			}
		],
		"servicesWhatWeOffer": {
			"title": "Services_Main_SubTitle",
			"paragraph": "Services_Main_SubTitle_Text"
		},
		"FeatureServices": {
			"servicesWhatWeOfferGrid": [
				{
					"title": "Services_Property_Title",
					"subtitle": "Services_Property_Title_Text",
					"icon": "ti-settings"
				},
				{
					"title": "Services_Property_Title2",
					"subtitle": "Services_Property_Title_Text2",
					"icon": "ti-ruler-pencil"
				},
				{
					"title": "Services_Property_Title3",
					"subtitle": "Services_Property_Title_Text3",
					"icon": "ti-face-smile"
				},
				{
					"title": "Services_Property_Title4",
					"subtitle": "Services_Property_Title_Text4",
					"icon": "ti-timer"
				},
				{
					"title": "Services_Property_Title5",
					"subtitle": "Services_Property_Title_Text5",
					"icon": "ti-rocket"
				},
				{
					"title": "Services_Property_Title6",
					"subtitle": "Services_Property_Title_Text6",
					"icon": "fa fa-eur"
				}
			]
		},
		"serviceshowWeWork": {
			"title": "Services_How_We_work",
			"paragraph": "empty"
		},
		"FeatureServicesInline": {
			"serviceshowWeWorkGrid": [
				{
					"title": "Services_How_We_work_Agile",
					"subtitle": "Services_How_We_work_Text1",
					"icon": "ti-stats-up"
				},
				{
					"title": "Services_How_We_work_Active",
					"subtitle": "Services_How_We_work_Text2",
					"icon": "ti-direction-alt"
				},
				{
					"title": "Services_How_We_work_Costs",
					"subtitle": "Services_How_We_work_Text3",
					"icon": "fa fa-eur"
				}
			]
		},
		"servicesQuestions": {
			"title": "Services_Frequently_Asked",
			"paragraph": "empty"
		},
		"FeaturesAccordionSection": {
			"servicesQuestionsList": [
				{
					"title": "About_Romania_and_BTandT",
					"questionsData": [
						{
							"qtitle": "Services_Question_One",
							"qanswer": "Services_Question_One_Answer"
						},
						{
							"qtitle": "Services_Question_Two",
							"qanswer": "Services_Question_Two_Answer"
						}
					]
				},
				{
					"title": "About_My_Project",
					"questionsData": [
						{
							"qtitle": "Services_Question_Three",
							"qanswer": "Services_Question_Three_Answer"
						},
						{
							"qtitle": "Services_Question_Four",
							"qanswer": "Services_Question_Four_Answer"
						},
						{
							"qtitle": "Services_Question_Five",
							"qanswer": "Services_Question_Five_Answer"
						},
						{
							"qtitle": "Services_Question_Six",
							"qanswer": "Services_Question_Six_Answer"
						},
						{
							"qtitle": "Services_Question_Seven",
							"qanswer": "Services_Question_Seven_Answer"
						}
					]
				},
				{
					"title": "About_The_Collaboration",
					"questionsData": [
						{
							"qtitle": "Services_Question_Eight",
							"qanswer": "Services_Question_Eight_Answer"
						},
						{
							"qtitle": "Services_Question_Nine",
							"qanswer": "Services_Question_Nine_Answer"
						},
						{
							"qtitle": "Services_Question_Ten",
							"qanswer": "Services_Question_Ten_Answer"
						},
						{
							"qtitle": "Services_Question_Eleven",
							"qanswer": "Services_Question_Eleven_Answer"
						},
						{
							"qtitle": "Services_Question_Twelve",
							"qanswer": "Services_Question_Twelve_Answer"
						},
						{
							"qtitle": "Services_Question_Thirteen",
							"qanswer": "Services_Question_Thirteen_Answer"
						}
					]
				}
			]
		}
	},
	"careerPage": {
		"CoverHeaderXs": [
			{
				"headerBackgroundImage": "img_bg_career.jpg",
				"headerSizeClass": "gtco-cover-xs",
				"headerTitle": "Career_Main_Title",
				"headerSubTitle": "Career_Main_TitleText"
			}
		],
		"careerDevelopYourself": {
			"title": "Career_Main_SubTitle",
			"paragraph": "Career_Main_SubTitle_Text"
		},
		"leftDeveloperYourselfParagraph": "Career_Main_SubTitle_Text_Body_Left",
		"rightDeveloperYourselfParagraph": "Career_Main_SubTitle_Text_Body_Right",
		"careerOurOffice": [
			{
				"title": "Career_Our_Office",
				"paragraph": "empty",
				"subtitle": "Career_Our_Working_At"
			}
		],
		"careerOurOfficeSubtitleParagraph": "Career_Our_Working_At_Text",
		"careerOurOfficeListLeft": [
			"Career_Our_Working_At_Elem",
			"Career_Our_Working_At_Elem1",
			"Career_Our_Working_At_Elem2",
			"Career_Our_Working_At_Elem3"
		],
		"careerOurOfficeListRight": [
			"Career_Our_Working_At_Elem4",
			"Career_Our_Working_At_Elem5",
			"Career_Our_Working_At_Elem6"
		],
		"carouselItems": [
			"img_1.jpg",
			"img_2.jpg",
			"img_3.jpg",
			"img_4.jpg"
		],
		"careerOurOpenings": "Career_Our_Current_Openings",
		"careerOurOpeningsParagraph": "Career_Our_Current_Openings_Text",
		"FeaturesAccordionSection": {
			"carrerOpenPositions": [
				{
					"title": "empty",
					"questionsData": [
						{
							"qtitle": "Career_Oracle_Dev",
							"qanswer": "Job_Oracle_Dev_Body"
						},
						{
							"qtitle": "MVC_software_developer",
							"qanswer": "Job_Mvc_Dev_Body"
						},
						{
							"qtitle": "Career_Front_Dev_Title",
							"qanswer": "Job_Web_Dev_Body"
						}
					]
				}
			]
		}
	},
	"blogPage": {
		"CoverHeaderXs": [
			{
				"headerBackgroundImage": "img_bg_blog.jpg",
				"headerSizeClass": "gtco-cover-xs",
				"headerTitle": "Blog_Main_Title",
				"headerSubTitle": "Contact_Main_SubTitle"
			}
		],
		"recentPosts": "Recent_Posts",
		"readMore": "Read More"
	},
	"contactPage": {
		"CoverHeaderXs": [
			{
				"headerBackgroundImage": "img_bg_contact.jpg",
				"headerSizeClass": "gtco-cover-xs",
				"headerTitle": "Contact_Main_Title",
				"headerSubTitle": "Contact_Main_SubTitle"
			}
		],
		"ContactWeHire": "Contact_Hire_Title",
		"ContactWeHireParagraph": "Contact_Hire_Title_Text",
		"contactGetInTouch": "Contact_Get_In_Touch",
		"contactContactInfo": "Contact_Contact_Information",
		"contactContactInfoList": [
			{
				"class": "address",
				"data": "Str. Dobrota 12, <br />  2nd floor, Bucharest, Romania"
			},
			{
				"class": "phone",
				"data": "<a href='tel://+4031805 90 75'>+40 (31) 805 90 75</a>"
			},
			{
				"class": "email",
				"data": "<a href='mailto:info@bttsd.com'>info@bttsd.com</a>"
			}
		],
		"mapDetails": {
			"lat": 44.460483,
			"lng": 26.102316,
			"key": "BT&T",
			"zoom": 15,
			"markerAnimation": 2
		},
		"containerStyle": {
			"height": "283px"
		},
		"elementStyle": {
			"height": "100%"
		},
		"submitButtonName": "Contact_Send_Message",
		"formDataSucessMessage": "Contact_Form_SuccessMessage",
		"formData": [
			{
				"name": "name",
				"component": "input",
				"type": "text",
				"placeholder": "Contact_Form_Name",
				"className": "form-control"
			},
			{
				"name": "email",
				"component": "input",
				"type": "email",
				"placeholder": "Contact_Form_Email",
				"className": "form-control"
			},
			{
				"name": "phone",
				"component": "input",
				"type": "text",
				"placeholder": "Contact_Form_Subject",
				"className": "form-control"
			},
			{
				"name": "message",
				"component": "textarea",
				"type": "textarea",
				"placeholder": "Contact_Form_Body",
				"className": "form-control",
				"columns": "30",
				"rows": "10"
			}
		]
	},
	"page_body": {
		"blogEntries": [
			{
				"title": "Blog_entry_Integrating_Skype_Title",
				"tags": "Integration, Project, Skype",
				"author": "BT&T",
				"date": "May 30, 2017",
				"short_entry": "Blog_entry_Integrating_Skype_Short_Entry",
				"image": "skype-for-business.png",
				"article_image": "blog-entry-1.jpg",
				"long_entry": "Blog_entry_Integrating_Skype_Long_Entry",
				"link_to_article": "skype-for-business-integration-project"
			},
			{
				"title": "Blog_entry_Hardware_Acceleration_WebKit_Title",
				"tags": "Tweaks, Css",
				"author": "BT&T",
				"date": "May 23, 2017",
				"short_entry": "Blog_entry_Hardware_Acceleration_WebKit_Short_Entry",
				"article_image": "blog-entry-1.jpg",
				"long_entry": "Blog_entry_Hardware_Acceleration_Long_Entry",
				"link_to_article": "hardware-acceleration-in-webkit"
			},
			{
				"title": "Nearshoring_Guide_Title",
				"tags": "News, Nearshoring",
				"author": "BT&T",
				"date": "May 16, 2017",
				"short_entry": "Nearshoring_Guide_Short_Entry",
				"image": "nearshoring-guide.jpg",
				"article_image": "blog-entry-1.jpg",
				"long_entry": "Nearshoring_Guide_Long_Entry",
				"link_to_article": "nearshoring-guide-available-for-download"
			},
			{
				"title": "Clearfix_Update_Title",
				"tags": "News, Nearshoring",
				"author": "BT&T",
				"date": "May 16, 2017",
				"short_entry": "Clearfix_Update_Short_Entry",
				"article_image": "blog-entry-1.jpg",
				"long_entry": "Clearfix_Update_Long_Entry",
				"link_to_article": "clearfix"
			}
		]
	},
	"header": {
		"languages": [
			"en",
			"nl",
			"ro"
		],
		"headerLogo": "BT_T_Logo1.png",
		"menuData": [
			{
				"name": "Header_Home",
				"link": ""
			},
			{
				"name": "Header_About",
				"link": "about",
				"submenuData": [
					{
						"name": "Header_Our_Philosophy",
						"link": "about#gtco-history"
					},
					{
						"name": "Header_Why_Romania",
						"link": "about#gtco-counter"
					},
					{
						"name": "Header_Our_Work",
						"link": "about#our-work"
					}
				]
			},
			{
				"name": "Header_Services",
				"link": "services",
				"submenuData": [
					{
						"name": "Services_Main_SubTitle",
						"link": "services#offer"
					},
					{
						"name": "Services_How_We_work",
						"link": "services#gtco-how-we-work"
					},
					{
						"name": "Services_Frequently_Asked",
						"link": "services#questions"
					}
				]
			},
			{
				"name": "Header_Career",
				"link": "career"
			},
			{
				"name": "Header_Blog",
				"link": "blog"
			},
			{
				"name": "Header_Contact",
				"link": "contact"
			}
		]
	},
	"footer": {
		"footerContentTitles": [
			{
				"title": "Footer_Member_Of",
				"imageChamber": "chamberofcommerce.png",
				"imagePartner": "MicrosoftPartnerLogo-black-small.png"
			},
			{
				"title": "Footer_Follow"
			},
			{
				"title": "Footer_Contact_Information"
			}
		],
		"footerCopyright": "Footer_Copyright",
		"footerPrivacyPolicy": "Footer_Privacy_Policy",
		"footerPrivacyPolicyContentFirstPart": "Footer_Privacy_Policy_Content_FirstPart",
		"footerPrivacyPolicyContentSecondPart": "Footer_Privacy_Policy_Content_SecondPart"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 52
// module chunks = 0